import React from 'react';
import withCustomComponent from 'ui/components/withCustomComponent';

import BlogPostCard from 'ui/bw-ui/blog/BlogPostCard';

export const BlogPageList = withCustomComponent('BlogPageList')(
  ({ componentName, blogPosts }) => (
    <div data-component-name={componentName} className="blog-page-list">
      <ul className="list-grid list-grid--33 list-grid--lg-50 list-grid--md-50 list-grid--sm-100">
        {blogPosts.map((blogPost) => (
          <li key={blogPost.Id}>
            <BlogPostCard blogPost={blogPost} />
          </li>
        ))}
      </ul>
    </div>
  ),
);
